import { render, staticRenderFns } from "./returnMaterialDetail.vue?vue&type=template&id=7abb36a5&scoped=true&"
import script from "./returnMaterialDetail.vue?vue&type=script&lang=js&"
export * from "./returnMaterialDetail.vue?vue&type=script&lang=js&"
import style0 from "./returnMaterialDetail.vue?vue&type=style&index=0&id=7abb36a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abb36a5",
  null
  
)

export default component.exports